import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyAT_HP36DbGDOKQ64HWiRtGPVcR-VD2PJY',
  authDomain: 'live-chat-24679.firebaseapp.com',
  projectId: 'live-chat-24679',
  storageBucket: 'live-chat-24679.appspot.com',
  messagingSenderId: '434523684531',
  appId: '1:434523684531:web:91ce8ff3292c5ba25fbac6',
};

// init firebase
firebase.initializeApp(firebaseConfig);

const projectAuth = firebase.auth();
const projectFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectAuth, projectFirestore, timestamp };
